module.exports = __webpack_public_path__ + "img/policyoptions.17269f1.svg";